module.exports = __webpack_public_path__ + "img/traffic-light-go.c16d2f11.svg";